import { Localization } from "libs/localization/localization"
import { EColors, EFonts } from "libs/style/w24_styling"
import React from "react"
import styled from "styled-components/macro"

interface Props {
  className?: string
}

export const MadeInNorway = (props: Props): JSX.Element => {
  return (
    <S_MadeInNorway className={props.className}>
      <S_Svg
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        viewBox="0 0 22 16"
      >
        <title>Flag of Norway</title>
        <rect width="22" height="16" fill="#ba0c2f" />
        <path d="M0,8h22M8,0v16" stroke="#fff" strokeWidth="4" />
        <path d="M0,8h22M8,0v16" stroke="#00205b" strokeWidth="2" />
      </S_Svg>
      <S_Title>{Localization.MADE_IN_NORWAY}</S_Title>
    </S_MadeInNorway>
  )
}

const S_MadeInNorway = styled.div`
  display: flex;
  gap: 20px;
  align-items: center;
`

const S_Svg = styled.svg`
  width: 42px;
`

const S_Title = styled.div`
  color: ${EColors.DARK};
  font-family: ${EFonts.Bold};
  font-size: 18px;
`
